import * as ResponsiveFns from './utilities/ResponsiveFns';
import * as CoreFns from './utilities/CoreFns';

export default function UpdateMain(changes, currentList, width, height){

	if (!currentList){
		return;
	}
	changes = JSON.parse(JSON.stringify(changes));
	changes.forEach((aChange, index)=>{

    	var ob = currentList;
    	var w = aChange.w;
    	if (aChange.t === 'r'){
	    	for (var i2 = 0; i2 < w.length; i2++){
	    		ob = ob[w[i2]];
	    	}
    		var id3 = aChange.i;
    		delete ob[id3];
    	}else{    		
	    	for (var i7 = 0; i7 < w.length - 1; i7++){
	    		if (!ob[w[i7]]){
	    			ob[w[i7]] = {}
	    		}
	    		ob = ob[w[i7]];
	    	}
	    	var lastNos = w[w.length - 1];
    		var currentValue = ob[lastNos];
			if (aChange.t === 'w'){
	    		currentValue = aChange.n;
	    		ob[lastNos] = currentValue;
	    	}else{
	    		var prior = getBeforeAfter(aChange.p, currentValue);
	    		if (!prior){
	    			console.log(aChange);
	    			console.log(currentValue);
	    		}
	    		var before = prior.before;
	    		var after = prior.after;
		    	if (aChange.t === 'a'){
		    		currentValue = before.concat(aChange.n).concat(after);
		    	}else if (aChange.t === 'd'){
		    		var prior2 = getBeforeAfter(aChange.l, after);
		    		currentValue = before.concat(prior2.after);
		    	// }else if (aChange.t === 'u'){
		    	// 	var prior3 = getBeforeAfter(aChange.l, after);
		    	// 	var before2 = prior3.before;
		    	// 	var updatedBefore = updateEach(before2, aChange.r, aChange.n);
		    	// 	currentValue = before.concat(updatedBefore).concat(prior3.after);
		    	}
		    	// currentValue = marchDownToConsolidate(currentValue);
	    		ob[lastNos] = currentValue;
	    	}

    	}

    // }
	})
}



function getBeforeAfter(length, value){

	function getAfter(i){
		return value.filter((aVal, index)=>{
				return +index > i;
			})		
	}

	for (var i = 0; i < value.length; i++){
		var thisValue = value[i];
		var vt = thisValue.t;
		if (length === 0){
			var before = ResponsiveFns.getBefore(value, i);
			var after = ResponsiveFns.getAfterIncl(value, i);
			return {before, after};
		}else if (vt === 'h' || vt === 'a' || vt === 'br'){
			length --;
		}else if (CoreFns.directV(vt) || CoreFns.withP(vt) || vt === 'u' || vt === 'eS' || vt === 'eV'  || vt === 'g' || vt === 'inP' || vt === 'footer' || vt === 'pa' || vt === 'al' || vt === 'd' || vt === 'pl' ){ //these are the formula options
			length --;
		}else if (vt === 't'){
			var textLength = thisValue.v.length;
			if (textLength <= length){
				length = length - textLength;
			}else{
				var beforeText = thisValue.v.substr(0, length);
				var afterText = thisValue.v.substr(length);
				var before1 = ResponsiveFns.getBefore(value, i);
				var after1 = getAfter(i);

				var style1 = JSON.parse(JSON.stringify(thisValue.s));
				var beforePart = {t:'t',v:beforeText,s:thisValue.s};
				var afterPart = {t:'t',v:afterText,s:style1};
				before1.push(beforePart);
				after1.unshift(afterPart);
				return {before:before1, after:after1};
			}
		}else if (vt === 'tb'){
			var textLength1 = thisValue.v.length;
			if (textLength1 <= length){
				length = length - textLength1;
			}else{
				var before11 = ResponsiveFns.getBefore(thisValue.v, length);
				var after11 = ResponsiveFns.getAfterIncl(thisValue.v, length);
				var before1X = ResponsiveFns.getBefore(value, i);
				var after1X = getAfter(i);

				var style12 = JSON.parse(JSON.stringify(thisValue.s));
				var beforePart1 = {t:'tb', v:before11, s:thisValue.s};
				var afterPart1 = {t:'tb', v:after11, s:style12};
				before1X.push(beforePart1);
				after1X.unshift(afterPart1);
				return {before:before1X, after:after1X};
			}
		}else{
			console.warn(thisValue);
		}

	}
	if (length === 0){
		return {before:value, after:[]};
	}
}




